// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';

import styles from './WhatMembersLove.scss';

export function WhatMembersLove() {
    return (
        <React.Fragment>
            <div className={styles.headerContainer}>
                <BarHeader
                    dataTn="header-whatRewardMembersLove"
                    size="xLarge"
                    title={
                        <FormattedMessage
                            id="abt.loyaltyModules.WhatMembersLove.whatRewardMembersLove"
                            defaultMessage="What Our Rewards Members Love"
                        />
                    }
                />
            </div>
            <div className={styles.modulesContainer}>
                <div className={styles.designerConnectionModule}>
                    <img
                        className={styles.designerConnectionImage}
                        src="https://a.1stdibscdn.com/assets/trade/rewards/members-designer-connection-graphic.jpg"
                    />
                    <div className={styles.modulePrimaryText}>
                        {/* Not intl'd because it's a branded name */}
                        {'Designer Connection'}
                    </div>
                    <div className={styles.moduleSecondaryText}>
                        <div className={styles.quote}>
                            {/* quotation not intl'd */}
                            {
                                '"This is a great way to tap into the 1stdibs network and create lasting relationships with high quality clientele. My experience was totally seamless and I was matched with the perfect client."'
                            }
                        </div>
                        <div className={styles.quoteAttribution}>
                            {/* name not intl'd */}
                            {'Louisa Roeder, Louisa G. Roeder, LLC'}
                        </div>
                    </div>
                </div>
                <div className={styles.imageCarouselModule}>
                    <div className={styles.imageCarousel}>
                        <img src="https://a.1stdibscdn.com/assets/trade/rewards/members-social-media.jpg?width=375" />
                        <img src="https://a.1stdibscdn.com/assets/trade/rewards/members-rooms-of-distinction.jpg?width=375" />
                        <img src="https://a.1stdibscdn.com/assets/trade/rewards/members-introspective.jpg?width=375" />
                        <img src="https://a.1stdibscdn.com/assets/trade/rewards/members-design-profile.jpg?width=375" />
                    </div>
                </div>
                <div className={styles.editorialFeatureModule}>
                    <span className={styles.modulePrimaryText}>
                        <FormattedMessage
                            id="abt.loyaltyModules.WhatMembersLove.whatRewardMembersLove.editorialFeature"
                            defaultMessage="Editorial Coverage / Branding"
                        />
                    </span>
                    <div className={styles.moduleSecondaryText}>
                        <div className={styles.quote}>
                            {/* quotation not intl'd */}
                            {
                                '"It\'s always nice having your work recognized--especially by such an incredible digital platform as 1stdibs. I\'m humbled and truly appreciative to be featured."'
                            }
                        </div>
                        <div className={styles.quoteAttribution}>
                            {/* name not intl'd */}
                            {'Brad Ford, Brad Ford ID'}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
